export default __webpack_public_path__ + "static/realWorldImg1-155d3255c1e7ec7c99be23de30ef51aa.png";